var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessionTimeout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.25 42.5C50.8945 42.5 42.5 50.8945 42.5 61.25C42.5 71.6055 50.8945 80 61.25 80C71.6055 80 80 71.6055 80 61.25C80 50.8945 71.6055 42.5 61.25 42.5ZM68.2812 63.5938H61.25C59.9545 63.5938 58.9062 62.5455 58.9062 61.25V54.2188C58.9062 52.9233 59.9545 51.875 61.25 51.875C62.5455 51.875 63.5938 52.9233 63.5938 54.2188V58.9062H68.2812C69.5767 58.9062 70.625 59.9545 70.625 61.25C70.625 62.5455 69.5767 63.5938 68.2812 63.5938Z",
    fill: "#C32A7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6028 3.65531C35.3669 1.40078 33.0163 0 30.4688 0C27.9212 0 25.5706 1.40078 24.3416 3.64375L0.917813 45.8061C0.309063 46.8727 0 48.0194 0 49.2188C0 53.0959 3.15406 56.25 7.03125 56.25H37.9738C39.8073 47.2561 46.8231 40.1584 55.7439 38.1252L36.6028 3.65531ZM30.4688 42.1875C29.1744 42.1875 28.125 41.1381 28.125 39.8438C28.125 38.5494 29.1744 37.5 30.4688 37.5C31.7631 37.5 32.8125 38.5494 32.8125 39.8438C32.8125 41.1381 31.7631 42.1875 30.4688 42.1875ZM32.8125 30.4688C32.8125 31.7642 31.7642 32.8125 30.4688 32.8125C29.1733 32.8125 28.125 31.7642 28.125 30.4688V21.0938C28.125 19.7983 29.1733 18.75 30.4688 18.75C31.7642 18.75 32.8125 19.7983 32.8125 21.0938V30.4688Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionTimeout);
export default __webpack_public_path__ + "static/media/session_timeout.2982f0f5b008f9a299510c32542e0c91.svg";
export { ForwardRef as ReactComponent };